var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as PropTypes from 'prop-types';
import * as _ from 'lodash';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { isBrowser, commonPropTypes } from '../../lib';
/**
 * An inner component that allows you to render children outside their parent.
 */
var PortalInner = /** @class */ (function (_super) {
    __extends(PortalInner, _super);
    function PortalInner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PortalInner.prototype.componentDidMount = function () {
        _.invoke(this.props, 'onMount', this.props);
    };
    PortalInner.prototype.componentWillUnmount = function () {
        _.invoke(this.props, 'onUnmount', this.props);
    };
    PortalInner.prototype.render = function () {
        var _a = this.props, children = _a.children, context = _a.context;
        return context && ReactDOM.createPortal(children, context);
    };
    PortalInner.propTypes = __assign({}, commonPropTypes.createCommon({
        animated: false,
        as: false,
        className: false,
        content: false,
        styled: false,
    }), { context: PropTypes.object, onMount: PropTypes.func, onUnmount: PropTypes.func });
    PortalInner.defaultProps = {
        context: isBrowser() ? document.body : null,
    };
    return PortalInner;
}(React.Component));
export default PortalInner;
